import { isPostalCode } from './validation'

const API_URL = 'https://jp-postal-code-api.ttskch.com/api/v1'

// 住所が取得できない（郵便番号の形式不正・存在しない等）場合は空文字を返す
// 呼び出し側では空文字の場合に入力済みの住所を書き換えないこと
async function fetchAddress(postalCode: string): Promise<string> {
  if (!isPostalCode(postalCode)) {
    return ''
  }
  const [pref, autonomy] = postalCode.split('-')
  const endPoint = `${API_URL}/${pref}${autonomy}.json`
  const res = await fetch(endPoint)
  if (res.status >= 300) {
    return ''
  }
  const json = await res.json()
  const { prefecture, address1, address2, address3, address4 } = json.addresses[0].ja
  return `${prefecture}${address1}${address2}${address3}${address4}`
}

export { fetchAddress }
